import Vue from "vue";
import Nprogress from "nprogress";

import ErrorHandler from "@/helpers/handlers/error";
import usersService from "@/services/users";
import router from "@/router";
import { i18n } from "@/main";
import { gtmEvent__removeUserData } from "@/helpers/gtm-events";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";
import * as Sentry from "@sentry/vue";
import mixpanel from "mixpanel-browser";

import posthog from "posthog-js";

export default {
  async authRequest({ commit }, { data, serviceMethod }) {
    Nprogress.start();
    try {
      const user = await serviceMethod(data);
      const email = data.email;
      const token = user.data.key;
      Nprogress.done();
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.USER,
        JSON.stringify({ token, email })
      );
      commit("LOGIN_USER", { token, email });
      Vue.notify({
        group: "default",
        type: "success",
        text: i18n.t("message.notification.userLoggedInSuccess")
      });

      gtmEvent__removeUserData();

      Sentry.configureScope(scope => scope.setUser(null));

      Vue.gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.LOGIN,
        method: "email"
      });
    } catch (error) {
      Nprogress.done();
      localStorage.removeItem(LOCAL_STORAGE_KEYS.COMPANY_ID);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATIONS_IMPORT_STATUS);
      ErrorHandler.displayError(error);
    } finally {
      Nprogress.done();
    }
  },

  async signUpWithLoginAndPassword({ dispatch }, data) {
    Vue.gtm.trackCustomEvent({
      event: GTM_EVENT_NAME.SIGN_UP,
      method: "email",
      marketing_consent: data.is_marketing_consent
    });

    await dispatch("authRequest", {
      data,
      serviceMethod: usersService.registerWithEmailAndPassword
    });
  },

  async acceptInvitation({ dispatch }, data) {
    await dispatch("authRequest", {
      data,
      serviceMethod: usersService.acceptInvitation
    });
  },

  async signInWithEmailAndPassword({ dispatch }, data) {
    await dispatch("authRequest", {
      data,
      serviceMethod: usersService.loginWithEmailAndPassword
    });
  },

  // TODO: Sign with FB
  signInUserWithFacebook() {},

  // TODO: Sign with Google
  signInUserWithGoogle() {},

  async logout({ commit }, redirect = true) {
    if (redirect) {
      router.push({ name: "session-login" }).catch(err => {
        throw new Error(`An error occurred: ${err}.`);
      });
    }
    localStorage.removeItem(LOCAL_STORAGE_KEYS.DEMO_USER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.COMPANY_ID);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATIONS_IMPORT_STATUS);
    commit("LOGOUT_USER");

    await usersService.logout();

    Vue.gtm.trackCustomEvent({
      event: GTM_EVENT_NAME.LOGOUT
    });
    this._vm.$setUserProperties({ login_status: "logged_out" });

    gtmEvent__removeUserData();

    Sentry.configureScope(scope => scope.setUser(null));

    posthog.reset(true);
    mixpanel.reset();
    commit("CLEAR_STORE", true, { root: true });
  },
  setPlanRestrictions({ commit }, planRestrictions) {
    commit("SET_PLAN_RESTRICTIONS", planRestrictions);
  }
};
